import { singleOptionToolFunc, noOptionToolFunc } from "../../utils";

const triangle = zwibbler => {
  zwibbler.usePolygonTool(3, 0);
  return { errorCode: 0 };
};

const star = zwibbler => {
  zwibbler.usePolygonTool(10, 0, 0.5);
  return { errorCode: 0 };
};

export const selectTool = (zwibbler, options) => {
  if (options.tool === "star") {
    return star(zwibbler);
  }

  if (options.tool === "triangle") {
    return triangle(zwibbler);
  }

  let functionName = singleOptionToolFunc(options.tool);
  if (functionName) {
    const properties = options.options ? options.options : {};
    zwibbler[functionName](properties);
    return { errorCode: 0 };
  }

  functionName = noOptionToolFunc(options.tool);
  if (functionName) {
    const properties = options.options ? options.options : {};
    zwibbler[functionName](properties);
    return { errorCode: 0 };
  }
};



// WEBPACK FOOTER //
// ./src/components/Zwibbler/ExternalApi/handlers/Tools.js